import { useFlags } from 'flagsmith/react';

/**
 * @param flag the name of the flag on flagsmith ex: fe_campaign_launcher_preview
 */
export function useFeatureManager(flag: string): boolean {
  const f = useFlags([flag]);
  return !!f[flag]?.enabled;
}
